import { Currency } from "./currency";
import { ICurrency, ICurrencyData } from "./currency.types";

export const mockCurrencyData = (): ICurrencyData[] => [
  {
    id: 1,
    code: "EUR",
    symbol: "€",
  },
  {
    id: 3,
    code: "USD",
    symbol: "$",
  },
  {
    id: 4,
    code: "PEN",
    symbol: "PEN",
  },
  {
    id: 5,
    code: "ARS",
    symbol: "ARS",
  },
  {
    id: 6,
    code: "BRL",
    symbol: "R$",
  },
];

export const mockCurrency = (data: ICurrencyData[] = mockCurrencyData()): ICurrency[] =>
  data.map((item) => new Currency(item));
